
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QRyreportDialog extends Serenity.EntityDialog<QRyreportRow, any> {
        protected getFormKey() { return QRyreportForm.formKey; }
        protected getIdProperty() { return QRyreportRow.idProperty; }
        protected getLocalTextPrefix() { return QRyreportRow.localTextPrefix; }
        protected getNameProperty() { return QRyreportRow.nameProperty; }
        protected getService() { return QRyreportService.baseUrl; }
        protected getDeletePermission() { return QRyreportRow.deletePermission; }
        protected getInsertPermission() { return QRyreportRow.insertPermission; }
        protected getUpdatePermission() { return QRyreportRow.updatePermission; }

        protected form = new QRyreportForm(this.idPrefix);

    }
}